// extracted by mini-css-extract-plugin
export default {"shippingDetails":"shippingDetails_shippingDetails__xWVtc","label":"shippingDetails_label__3v+vw"};